<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="240px">
            <el-form-item label="分部编号：" prop="branch_code">
                <el-input v-model="model.branch_code" @input="branchCodeChange"></el-input>
            </el-form-item>
            <el-form-item label="单元编号：" prop="unit_code">
                <el-select clearable v-model="model.unit_code" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in unitList" :key="'unit_code'+item.key" :label="item.code" :value="item.code"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="基础编号：" prop="base_index">
                <el-input v-model="model.base_index"></el-input>
            </el-form-item>
            <el-form-item label="排/环号：" prop="base_name">
                <el-input v-model="model.base_name"></el-input>
            </el-form-item>
            <el-form-item label="基准起点坐标：" prop="datum_point1">
                <el-input v-model="model.datum_point1"></el-input>
            </el-form-item>
            <el-form-item label="基准终点坐标：" prop="datum_point2">
                <el-input v-model="model.datum_point2"></el-input>
            </el-form-item>
            <el-form-item label="第一个点距离基准起点的距离：" prop="b_offset">
                <el-input v-model="model.b_offset"></el-input>
                <span class="tips">单位：mm</span>
            </el-form-item>
            <el-form-item label="最后一个点距离基准终点的距离：" prop="e_offset">
                <el-input v-model="model.e_offset"></el-input>
                <span class="tips">单位：mm</span>
            </el-form-item>
            <!-- <el-form-item label="孔距：" prop="pitch">
                <el-input v-model="model.pitch"></el-input>
                <span class="tips">单位：mm</span>
            </el-form-item> -->
            <el-form-item label="偏移量：" prop="distance_y">
                <el-input v-model="model.distance_y"></el-input>
                <span class="tips">基于图纸向上为正，向下为负。单位：mm</span>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type">
                <el-select clearable v-model="model.grout_type" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="孔直径：" prop="diameter">
                <el-input v-model="model.diameter"></el-input>
            </el-form-item>
            <el-form-item label="孔方向：" prop="up_index">
                <el-select clearable v-model="model.up_index" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in enuObj('hole_up_index')" :key="'up_index'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="孔数：" prop="hole_count">
                <el-input v-model.number="model.hole_count"></el-input>
            </el-form-item>
            <el-form-item label="循序：" prop="sequential">
                <el-select clearable v-model="model.sequential" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in enuObj('sequential')" :key="'sequential'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById } from '@/api/common'
import { getUnitListByBranch } from '@/api/org'

export default {
    name: 'arrangeEdit',
    mixins: [editutil],
    props: {
        branch_code: {
            type: String,
            default() {
                return '';
            }
        },
    },
    data() {
        return {
            model: {
                branch_code: '',
                unit_code: '',
                base_name: '',
                base_index: '',
                datum_point1: '',
                datum_point2: '',
                b_offset: '',
                e_offset: '',
                pitch: '',
                distance_y: '',
                grout_type: '',
                diameter: '',
                up_index: '',
                sequential: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/arrange/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type', 'hole_up_index', 'sequential'],
            rules: {
                branch_code: [
                    {required: true, message: '分部工程编号不能为空', trigger: 'blur'}
                ],
                unit_code: [
                    {required: true, message: '单元编号不能为空', trigger: 'blur'}
                ],
                base_name: [
                    {required: true, message: '排号不能为空', trigger: 'blur'}
                ],
                base_index: [
                    {required: true, message: '基础编号不能为空', trigger: 'blur'}
                ],
                datum_point1: [
                    {required: true, message: '基准起点坐标不能为空', trigger: 'blur'}
                ],
                datum_point2: [
                    {required: true, message: '基准终点坐标不能为空', trigger: 'blur'}
                ],
                b_offset: [
                    {required: true, message: '第一个点距离基准起点的距离不能为空', trigger: 'blur'}
                ],
                e_offset: [
                    {required: true, message: '最后一个点距离基准终点的距离不能为空', trigger: 'blur'}
                ],
                // pitch: [
                //     {required: true, message: '孔距不能为空', trigger: 'blur'}
                // ],
                distance_y: [
                    {required: true, message: '垂直偏移量不能为空', trigger: 'blur'}
                ],
                grout_type: [
                    {required: true, message: '灌浆类型不能为空', trigger: 'blur'}
                ],
                diameter: [
                    {required: true, message: '孔直径不能为空', trigger: 'blur'}
                ],
                up_index: [
                    {required: true, message: '孔方向不能为空', trigger: 'blur'}
                ],
                hole_count: [
                    {required: true, message: '孔数不能为空', trigger: 'blur'},
                    {type: 'number', message: '孔数必须是数字值', trigger: 'blur'}
                ],
                sequential: [
                    {required: true, message: '循序不能为空', trigger: 'blur'}
                ],
            },
            unitList: [],
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/arrange/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        this.formateData();
                        this.branchCodeChange(this.model.branch_code)
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }else if(this.$isNotNull(this.branch_code)){
                this.model.branch_code = this.branch_code
                this.branchCodeChange(this.model.branch_code)
            }
        },
        formateData(){
            this.model.grout_type = this.model.grout_type+""
            this.model.up_index = this.model.up_index+""
            this.model.sequential = this.model.sequential+""
        },
        branchCodeChange(e){
            getUnitListByBranch(e).then(res=>{
                if(res.code == 1){
                    this.unitList = res.data
                }
            })
        }
    }
};
</script>